export const COOKIE_CONSENT_STORAGE_KEY = 'projectSecretaryCookieConsent.v2';
export const GTM_ID = 'GTM-NMM7VHG2';

export type CookieConsentChoice = {
  necessary: true;
  optional: boolean;
  decidedAt: string;
  version: 2;
};

export const readCookieConsent = (): CookieConsentChoice | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const raw = window.localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw) as Partial<CookieConsentChoice>;
    if (parsed.version !== 2 || parsed.necessary !== true || typeof parsed.optional !== 'boolean') {
      return null;
    }

    return parsed as CookieConsentChoice;
  } catch {
    return null;
  }
};

export const writeCookieConsent = (optional: boolean): CookieConsentChoice => {
  const choice: CookieConsentChoice = {
    necessary: true,
    optional,
    decidedAt: new Date().toISOString(),
    version: 2,
  };

  try {
    window.localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, JSON.stringify(choice));
  } catch {
    // Some browsers block localStorage. Keep the in-memory choice for this session.
  }

  return choice;
};
